define(['jquery'], function ($) {
    (function () {
        'use strict';

        var $tabContainer = $('.tab-wrapper'),
            $tabs = $('.tabs-mod'),
            $overviewHead = $('.mod-intro'),
            $tabLlinks = $('.tabs  .nav__link'),
            $tabList = $tabs.find('.tabs'),
            $tabLabel = $('.tabs__label');

        $('.nav__item').not('.pro_link').click(function () {
            var tabName = $(this).attr('data-tabName'),
                $curContent = $('.tab-item').not('.offscreen'),
                $offscreen = $('.offscreen[data-tabName=' + tabName + ']');

            if (tabName !== $curContent.attr('data-tabName')) {
                (tabName === 'overview') ?
                $overviewHead.slideDown('300') :
                    $overviewHead.slideUp('300');

                $curContent.fadeOut(function () {
                    $tabContainer.css('height', $offscreen.css('height') + 10);
                    $curContent.addClass('offscreen');
                    $offscreen.removeClass('offscreen').fadeIn('300');
                });
            }
        });

        function addItemClass() {
            var $this = $(this),
                $navItems = $('.tabs .nav__link'),
                $contextTabs = $this.closest('.tabs');

            $navItems.not($this).removeClass('is-active');

            $this.addClass('is-active');

            if (window.innerWidth < 750) {
                updateText($contextTabs);
                closeMobileDropdown($contextTabs);
            }
        }

        function closeMobileDropdown(tabListClose) {
            tabListClose.prev('.tabs__label').removeClass('js-is-active');
            tabListClose.slideUp('300');
        }

        $tabLlinks.click(addItemClass);

        function updateText($tabsContext) {
            var $currentActiveText = $tabsContext.find('.is-active').text();
            $tabsContext.prev().text($currentActiveText);
        }

        $tabList.each(function (e) {
            var $this = $(this),
                $currentActiveTab = $this.find('.is-active').text();
            $this.prev().text($currentActiveTab);

        });

        if (window.innerWidth < 750) {

            var $mobileForm = $('.mobile-form');

            if (!!$mobileForm) {
                var $keyworkList = $mobileForm.find('.filter-options__keyword'),
                    $mobileFormContent = $mobileForm.find('.mobile-form__content'),
                    $mobileFormLabel = $mobileForm.find('.mobile-form__label');
            }
        }

        $tabLabel.on('click', function () {
            var _self = $(this);

            if (!_self.hasClass('js-is-active')) {
                _self.addClass('js-is-active');
                _self.next('.tabs').slideDown('300');
            } else {
                _self.removeClass('js-is-active');
                _self.next('.tabs').slideUp('300');

            }
        });

        window.addEventListener('popstate', function (event) {
            //look for tab
        });

        $tabs.each(function (e) {
            var $this = $(this),
                $fancyBorder = $this.contents('.tabs__border'),
                borderTimer = window.setTimeout('');

            var setBorder = function ($item) {
                window.clearTimeout(borderTimer);
                borderTimer = window.setTimeout(function () {
                    try {
                        $fancyBorder.animate({
                            'left': $item.position().left,
                            'width': $item.css('width')
                        }, 100);
                    } catch (e) { }
                }, 100);
            };

            try {
                $fancyBorder.css('left', $this.find('.tabs .is-active').position().left).css('width', $this.find('.tabs .is-active').css('width'));
            } catch (e) {

            }
            setBorder($this.find('.tabs .is-active'));
            $this.find('.tabs .nav__link').hover(function () {
                setBorder($(this));
            });
            $this.find('.tabs').hover(void 0, function () {
                setBorder($this.find('.tabs .is-active'));
            })
        });

    })();
});